module.exports = __webpack_public_path__ + "img/luyuanRewardExclusiveTag.6d8f9b69.png";